export default __webpack_public_path__ + "47805ef973891a85b62c0c3e704e2d2d.mp4";